import "./RoleSelect.less";

import TeacherIcon from "../../../assets/images/Teacher_Icon.svg";

import React, { Component } from "react";
import { translate } from "react-i18next";
import i18n from "i18next";
import { CreateAccountContext } from "../../../contexts/contexts";

const TEACHER = "teacher";
const STUDENT = "student";

const POSSIBLE_SCHOOLS = [
	{ default: "NL", id: "nl-BE", name: "vlaanderen" },
	{ default: "FR", id: "fr-BE", name: "brussels" }
];

class RoleSelect extends Component {
	static contextType = CreateAccountContext;

	state = {
		role: this.props.role || TEACHER,
		school: this.props.school || POSSIBLE_SCHOOLS.find(school => school.default === i18n.language.toUpperCase())
	};

	render() {
		const t = this.props.t;

		const schoolSelector = (
			<div className="dropdown show">
				<p>{t("role.schoolsLocation")}</p>

				<a
					className="btn btn-secondary dropdown-toggle"
					href="#"
					role="button"
					id="dropdownMenuLink"
					data-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					{t(`role.${this.getSelectedSchool().name}`)}
				</a>

				<div className="dropdown-menu" aria-labelledby="dropdownMenuLink">
					{POSSIBLE_SCHOOLS.map(school => (
						<a key={school.id} className="dropdown-item" href="#" onClick={e => this.handleSchoolChange(e, school)}>
							{t(`role.${school.name}`)}
						</a>
					))}
				</div>
			</div>
		);

		return (
			<div className="role_select">
				<p>{t("pleaseSelect")}</p>

				<div className="selectors">
					<div className="teacher">
						<img src={TeacherIcon} alt="" onClick={this.handleRoleImageClick.bind(this, TEACHER)} />
						<label className="radio">
							<input name="radio" type="radio" value={TEACHER} checked={this.isChecked(TEACHER)} onChange={this.handleRoleChange.bind(this)} />
							<span>{t("role.teacher")}</span>
						</label>
					</div>

				</div>
				<div>{schoolSelector}</div>
				<button className="btn btn-secondary" onClick={this.nextClickHandler.bind(this)}>
					{t("next")}
				</button>
			</div>
		);
	}

	handleSchoolChange(event, school) {
		event.preventDefault();
		this.setState({ school });
	}

	getSelectedSchool() {
		return this.state.school;
	}

	handleRoleImageClick(value) {
		this.setState({ role: value });
	}

	handleRoleChange(event) {
		this.setState({ role: event.target.value });
	}

	isChecked(role) {
		return this.state.role === role;
	}

	nextClickHandler() {
		this.context.setRole(this.state.role);
		this.context.setSchool(this.getSelectedSchool());
		if (this.state.role === STUDENT) {
			this.props.goToStep(3);
		} else {
			this.props.nextStep();
		}
	}
}

const translateRoleSelect = translate("registration")(RoleSelect);

export { translateRoleSelect as RoleSelect };



// WEBPACK FOOTER //
// ./src/components/CreateAccount/RoleSelect/RoleSelect.js